var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-notice-bar',{style:(_vm.nStyle),attrs:{"id":"tipsNotice","speed":40,"text":"本课程版权归本公司所有，仅限个人学习，严禁任何形式的录制、传播和账号分享，一经发现，平台将依法保留追究权，情节严重者将承担法律责任。"}})
}
var staticRenderFns = []

export { render, staticRenderFns }